<template>
  <div id="wrapper">
    <SidebarView :budgets="true" :budgetsDashboard="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <div class="container">
          <div class="card card-shape home-box">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col-12">
                  <h6 class="m-0 fw-bold text-green">Budget Dashboard</h6>
                  <div class="small text-muted">Budget ID: {{ budgetId }}</div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <b-alert show variant="secondary">
                Optional shortcut view. Canonical reporting is under Reports → Budgetary.
              </b-alert>
              <a href="/reports" class="btn akkurate-green-btn text-white btn-size me-2">Go to Budgetary Reports</a>
              <a href="/budgets" class="btn akkurate-gray-btn text-white btn-size">Back to Budgets</a>
            </div>
          </div>
        </div>
      </div>
      <footer></footer>
    </div>
    <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
  </div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";

export default {
  name: "BudgetDashboard",
  components: { SidebarView, TopbarView },
  computed: {
    budgetId() {
      return this.$route?.params?.budgetId;
    },
  },
};
</script>

